import React, { useEffect, useState } from "react";

import {
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import MUIDataTable from "mui-datatables";
import Loader from "../../../components/loader/Loader";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { hideConfirmModal, showModal } from "../../../redux/counterSlice";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DispatchImageUpload from "../../../components/form-components/DispatchImageUpload";
import { MessageOutlined } from "@mui/icons-material";
import BoltIcon from "@mui/icons-material/Bolt";

function ViewDispatchOrders() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);
  const [formData, setFormData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openImage, setOpenImage] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedPrepareImage, setSelectedPrepareImage] = useState(null);
  const [commentPopup, setCommentPopup] = useState({
    flag: false,
    comments: "",
  });

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [addonList, setAddonList] = useState([]);
  const [dispatchOrder, setDispatchOrder] = useState(null);
  const [orderId, setOrderId] = useState();
  const [dispatchPrepareImages, setDispatchPrepareImages] = useState([]);

  const loadInitialData = () => {
    const url = "/getDispatchOrderByDispatchId/" + id;
    setLoader(true);
    handleClose();
    axios
      .get(url)
      .then(function (response) {
        setDispatchOrder(response?.data?.data);
        setOrderList(response?.data?.data?.[0]?.order?.ordered_products);
        setAddonList(response?.data?.data?.[0]?.order?.ordered_addons);
        setOrderId(response?.data?.data?.[0]?.order_id);
      })
      .catch(function (err) {
        toast.error(err?.message);
      })
      .finally(() => {
        setLoader(false);
        dispatch(hideConfirmModal({ msg: "" }));
      });
  };
  const seenAddonIds = new Set();
  const uniqueAddons = (addonList || []).filter((addon) => {
    if (addon.parent_id !== null && addon.parent_id !== undefined) return false; // skip combo addons
    const id = String(addon?.addon_id);
    if (seenAddonIds.has(id)) return false;
    seenAddonIds.add(id);
    return true;
  });
  const isCombo = (row) => row?.combo_price > 0;

  /** ---------- Combine products + addons similar to first component ---------- */
  const combinedDataRaw = [
    ...orderList.map((order, index) => ({
      ...order,
      type: "Cake",
      image: order?.product_details?.[0]?.images?.[0]?.app_product_image || "",
      product_name: order?.product_details?.[0]?.product_name || "-",
      weight: `${order?.variation?.weight?.[0]?.weight_name || "-"} ${
        order?.variation?.weight?.[0]?.unit?.unit_name || ""
      }`,
      quantity: order?.product_quantity || "-",
      cake_type:
        order?.egg_or_eggless === 0
          ? "Egg"
          : order?.egg_or_eggless === 1
            ? "Eggless"
            : "-",
      flavour:
        order?.flavour?.flavour_name !== "Default"
          ? order?.flavour?.flavour_name
          : "-",
      message_on_cake: order?.message_on_cake || "-",
      slot: onlyStartTime(dispatchOrder?.[0]?.order?.slot_timing),
      delivery_date: dispatchOrder?.[0]?.order?.expected_delivery,
      isCake: true,
      orderObj: order, // Pass full order object for upload handler
    })),
    ...uniqueAddons.map((addon) => ({
      ...addon,
      type: "Addon",
      image: addon?.image || "",
      product_name: addon?.product_name || "-",
      weight: "-",
      quantity: addon?.quantity || "-",
      cake_type: "-",
      flavour: "-",
      message_on_cake: "-",
      slot: onlyStartTime(dispatchOrder?.[0]?.order?.slot_timing),
      delivery_date: dispatchOrder?.[0]?.order?.expected_delivery,
      isCake: false,
      orderObj: null,
      isAddon: true,
    })),
  ];

  const combosByParentId = {};
  const normalProducts = [];
  const includedComboParentIds = new Set();

  combinedDataRaw.forEach((item) => {
    const parentDetails = item.parent_product_details?.[0];

    if (parentDetails) {
      const parentId = parentDetails.id;

      if (!includedComboParentIds.has(parentId)) {
        includedComboParentIds.add(parentId);

        normalProducts.push({
          id: parentId,
          product_name: parentDetails.product_name,
          product_price: parentDetails.combo_price,
          product_discount_price:
            item.product_discount_price || parentDetails.combo_price,
          image:
            parentDetails.images?.[0]?.app_product_image ||
            parentDetails.images?.[0]?.product_image ||
            null,
          product_quantity: item.product_quantity || item.quantity || 1,
          product_total:
            item.product_total || item.total || parentDetails.combo_price,
          isComboGroup: true,
          combo_price: parentDetails.combo_price || 0,
          egg_or_eggless: parentDetails.egg_or_eggless,
          combo_product_names:
            parentDetails.combo_products || item.combo_product_names,
          combos: [],
          comboParent: { ...parentDetails },
          type: "Combo",
          weight: `${item?.variation?.weight?.[0]?.weight_name || "-"} ${
            item?.variation?.weight?.[0]?.unit?.unit_name || ""
          }`,
          cake_type:
            parentDetails?.egg_or_eggless === 0
              ? "Egg"
              : parentDetails?.egg_or_eggless === 1
                ? "Eggless"
                : "-",
          flavour:
            parentDetails?.flavour?.flavour_name !== "Default"
              ? parentDetails?.flavour?.flavour_name
              : "-",
          message_on_cake: parentDetails?.message_on_cake || "-",
          slot: onlyStartTime(dispatchOrder?.[0]?.order?.slot_timing),
          delivery_date: dispatchOrder?.[0]?.order?.expected_delivery,
          isCake: true,
          orderObj: parentDetails,
        });
      }

      const comboGroupIndex = normalProducts.findIndex(
        (p) => p.id === parentId && p.isComboGroup,
      );
      if (comboGroupIndex !== -1) {
        normalProducts[comboGroupIndex].combos.push({
          ...item,
          isComboChild: true,
          parent_combo_id: parentId,
        });
      }
    } else if (item.combo_price > 0) {
      combosByParentId[item.id] = combosByParentId[item.id] || {
        comboParent: item,
        combos: [],
      };
    } else {
      normalProducts.push(item);
    }
  });

  const comboGroups = Object.values(combosByParentId)
    .filter(
      (g) =>
        g.comboParent && g.comboParent.combo_price > 0 && g.combos.length > 0,
    )
    .map((g) => ({
      ...g.comboParent,
      isComboGroup: true,
      combos: g.combos,
      comboParent: g.comboParent,
      type: "Combo",
      weight: `${g.comboParent?.variation?.weight?.[0]?.weight_name || "-"} ${
        g.comboParent?.variation?.weight?.[0]?.unit?.unit_name || ""
      }`,
      cake_type:
        g.comboParent?.egg_or_eggless === 0
          ? "Egg"
          : g.comboParent?.egg_or_eggless === 1
            ? "Eggless"
            : "-",
      flavour:
        g.comboParent?.flavour?.flavour_name !== "Default"
          ? g.comboParent?.flavour?.flavour_name
          : "-",
      message_on_cake: g.comboParent?.message_on_cake || "-",
      slot: onlyStartTime(dispatchOrder?.[0]?.order?.slot_timing),
      delivery_date: dispatchOrder?.[0]?.order?.expected_delivery,
      isCake: true,
      orderObj: g.comboParent,
    }));

  const combinedTableData = [...normalProducts, ...comboGroups];

  const columns = [
    {
      name: "dispatch_prepare_image_id",
      label: "S. No",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return <p>{+dataIndex + 1}</p>;
        },
      },
    },
    {
      name: "image",
      label: "Image",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const imageUrl = dispatchPrepareImages[dataIndex]?.image;
          return imageUrl ? (
            <PhotoProvider>
              <PhotoView key={dataIndex} src={imageUrl}>
                <img
                  src={imageUrl}
                  alt=""
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                />
              </PhotoView>
            </PhotoProvider>
          ) : (
            <h3>-</h3>
          );
        },
      },
    },
    {
      name: "product_name",
      label: "Name",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <p>{dispatchPrepareImages[dataIndex]?.product?.product_name}</p>
          );
        },
      },
    },
    {
      name: "Status",
      options: {
        customBodyRenderLite: (dataIndex) => {
          let status = null;
          let chipColor = null;
          const approve_status =
            dispatchPrepareImages[dataIndex]?.approve_status;
          if (approve_status == null) {
            status = "Pending";
            chipColor = "bg-warning";
          } else if (approve_status == 1) {
            status = "Approved";
            chipColor = "bg-success";
          } else if (approve_status == 0) {
            status = "Rejected";
            chipColor = "bg-danger";
          }
          return (
            <Chip
              className={chipColor}
              label={status}
              color="primary"
              size="small"
            />
          );
        },
      },
    },
    {
      name: "Comments",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const comments = dispatchPrepareImages[dataIndex]?.comments;

          return comments ? (
            <MessageOutlined
              color="primary"
              size="small"
              style={{ cursor: "pointer", marginLeft: 8 }}
              onClick={() => setCommentPopup({ flag: true, comments })}
            />
          ) : (
            "-"
          );
        },
      },
    },
  ];

  const itemColumns = [
    {
      name: "serial",
      label: "S. No",
      options: { customBodyRenderLite: (i) => i + 1 },
    },
    {
      name: "image",
      label: "Image",
      options: {
        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];
          const dataRow = row.isComboGroup ? row.comboParent : row;
          const url =
            dataRow?.product_details?.[0]?.images?.[0]?.app_product_image ||
            dataRow?.image ||
            dataRow?.images?.[0]?.app_product_image;

          return url ? (
            <PhotoProvider>
              <PhotoView src={url}>
                <img
                  src={url}
                  alt=""
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: 4,
                    cursor: "pointer",
                  }}
                />
              </PhotoView>
            </PhotoProvider>
          ) : (
            "-"
          );
        },
      },
    },
    {
      name: "product_name",
      label: "Product Name",
      options: {
        setCellProps: () => ({
          style: {
            textAlign: "center", // ✅ center table cell
          },
        }),

        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];
          const dataRow = row.isComboGroup ? row.comboParent : row;

          const name =
            dataRow?.product_details?.[0]?.product_name || row?.product_name;

          const isEggless = dataRow?.egg_or_eggless === 1;

          const isPhotoCake =
            dataRow?.product_details?.[0]?.photo_cakes_images?.length > 0;

          const fastDelivery =
            Number(dataRow?.fast_delivery) === 1 ||
            Number(dataRow?.product_details?.[0]?.fast_delivery) === 1 ||
            dataRow?.variation?.egg_preparation === "1" ||
            dataRow?.variation?.eggless_preparation === "1";
          const isBulk = Number(dataRow?.is_bulk_product) > 0;
          const isFreeProduct =
            Number(dataRow?.is_offer_reward) === 1 ||
            Boolean(dataRow?.is_free_product) ||
            dataRow?.free_tag === "FREE" ||
            (!dataRow?.isAddon &&
              Number(dataRow?.combo_price || 0) === 0 &&
              Number(dataRow?.product_total) === 0 &&
              Number(dataRow?.product_quantity) > 0);

          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "6px",
                textAlign: "center",
              }}
            >
              <span>
                {name}
                {isEggless && <span style={{ color: "red" }}> (Eggless)</span>}
              </span>

              {row.isComboGroup && row.combos?.length > 0 && (
                <span
                  style={{
                    backgroundColor: "#dc3545",
                    color: "white",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    padding: "2px 8px",
                    borderRadius: "4px",
                  }}
                >
                  COMBO
                </span>
              )}

              {isPhotoCake && (
                <span
                  style={{
                    backgroundColor: "#dc3545",
                    color: "white",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    padding: "2px 8px",
                    borderRadius: "4px",
                  }}
                >
                  Photo Cake
                </span>
              )}
              {isFreeProduct && (
                <span
                  title="Free Product"
                  className="free-tag"
                  style={{
                    backgroundColor: "#e5232a",
                    color: "white",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    padding: "2px 8px",
                    borderRadius: "4px",
                  }}
                >
                  FREE
                </span>
              )}
              {isBulk && ( // ✅ ADD
                <span
                  title="Bulk Product"
                  style={{
                    backgroundColor: "#e91e63",
                    color: "white",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    padding: "2px 8px",
                    borderRadius: "4px",
                  }}
                >
                  BULK
                </span>
              )}
              {fastDelivery && (
                <span
                  title="Fast Delivery"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    // background: "linear-gradient(135deg, #FF6B00, #FFB347)",
                    color: "white",
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    padding: "2px 8px",
                    borderRadius: "12px",
                  }}
                >
                  <BoltIcon
                    sx={{ fontSize: 26, color: "#FF6B00", rotate: "15deg" }}
                  />
                </span>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "photo",
      label: "Photo",
      options: {
        display: combinedTableData.some(
          (p) => p?.product_details?.[0]?.photo_cakes_images?.length > 0,
        ),
        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];
          const dataRow = row.isComboGroup ? row.comboParent : row;
          const img =
            dataRow?.product_details?.[0]?.photo_cakes_images?.[0]
              ?.photo_cake_image;

          return img ? (
            <PhotoProvider>
              <PhotoView src={img}>
                <img
                  src={img}
                  alt=""
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: 4,
                    cursor: "pointer",
                  }}
                />
              </PhotoView>
            </PhotoProvider>
          ) : (
            "-"
          );
        },
      },
    },
    // {
    //   name: "type",
    //   label: "Type",
    //   options: {
    //     customBodyRenderLite: (i) => {
    //       const row = combinedTableData[i];
    //       const dataRow = row.isComboGroup ? row.comboParent : row;

    //       // Check if photo_cakes_images exist and has length > 0
    //       if (dataRow?.product_details?.[0]?.photo_cakes_images?.length > 0) {
    //         return "Photo Cake";
    //       }

    //       // Otherwise show original type
    //       return row.type;
    //     },
    //   },
    // },

    {
      name: "weight",
      label: "Weight",
      options: {
        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];
          const dataRow = row.isComboGroup ? row.comboParent : row;
          if (dataRow?.variation?.weight?.[0]) {
            const w = dataRow.variation.weight[0];
            return `${w.weight_name} ${w.unit.unit_name}`;
          }
          return row.weight || "-";
        },
      },
    },
    {
      name: "quantity",
      label: "Quantity",
      options: {
        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];
          return row?.product_quantity || row?.quantity || "-";
        },
      },
    },
    {
      name: "cake_type",
      label: "Cake Type",
      options: {
        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];
          const dataRow = row.isComboGroup ? row.comboParent : row;

          if (dataRow?.egg_or_eggless === 0) return "Egg";
          if (dataRow?.egg_or_eggless === 1) return "Eggless";
          return row.cake_type || "-";
        },
      },
    },
    {
      name: "flavour",
      label: "Flavour",
      options: {
        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];
          const dataRow = row.isComboGroup ? row.comboParent : row;
          const f = dataRow?.flavour?.flavour_name;
          return f && f !== "Default" ? f : row.flavour || "-";
        },
      },
    },
    {
      name: "message_on_cake",
      label: "Message on Cake",
      options: {
        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];
          const dataRow = row.isComboGroup ? row.comboParent : row;
          return dataRow?.message_on_cake || row.message_on_cake || "-";
        },
      },
    },
    {
      name: "slot",
      label: "Slot",
    },
    {
      name: "delivery_date",
      label: "Delivery Date",
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRenderLite: (i) => {
          const row = combinedTableData[i];

          if (row.isCake && dispatchOrder?.[0]?.dispatch_order_status === 1) {
            return (
              <Button
                variant="contained"
                color="info"
                size="small"
                onClick={() => imageUploadHandler(row.orderObj)}
                style={{ minWidth: 120 }}
                className="cusBtn"
              >
                Upload Image
              </Button>
            );
          }

          return "-";
        },
      },
    },
  ];

  const hasComboProduct = combinedTableData.some(
    (row) =>
      row?.isComboGroup === true &&
      Array.isArray(row.combos) &&
      row.combos.length > 0,
  );

  const itemTableOptions = {
    selectableRows: false,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 20],
    download: false,
    print: false,
    viewColumns: true,
    filter: false,

    expandableRows: true,
    expandableRowsOnClick: true,
    expandableRowsHideExpander: false,

    // Only combo rows are expandable
    isRowExpandable: (dataIndex) => {
      const row = combinedTableData[dataIndex];
      return (
        row?.isComboGroup === true &&
        Array.isArray(row.combos) &&
        row.combos.length > 0
      );
    },

    setRowProps: (row, dataIndex, rowIndex) => {
      const rowData = combinedTableData[dataIndex];
      return {
        className: rowData?.isComboGroup ? "combo-row" : "normal-row",
      };
    },

    renderExpandableRow: (rowData, rowMeta) => {
      const parentRow = combinedTableData[rowMeta.dataIndex];
      if (!parentRow.isComboGroup || !parentRow.combos?.length) return null;

      return (
        <tr>
          <td colSpan={itemColumns.length + 1}>
            <Box sx={{ p: 2, backgroundColor: "#fafafa" }}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", mb: 2 }}
              >
                Combo Items (
                {parentRow.combos.length +
                  (parentRow.combos?.[0]?.combo_addon_details?.length || 0)}
                )
              </Typography>
              <Box
                display="grid"
                gridTemplateColumns="repeat(auto-fit, minmax(260px, 1fr))"
                gap={1.5}
              >
                {parentRow.combos.map((c, idx) => {
                  const img =
                    c?.product_details?.[0]?.images?.[0]?.app_product_image ||
                    c?.image ||
                    c?.images?.[0]?.app_product_image;
                  const name =
                    c?.product_details?.[0]?.product_name || c?.product_name;

                  return (
                    <Box
                      key={idx}
                      sx={{
                        border: "1px solid #ddd",
                        borderRadius: 2,
                        p: 1.5,
                        bgcolor: "background.paper",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {img ? (
                          <PhotoProvider>
                            <PhotoView src={img}>
                              <img
                                src={img}
                                alt={name}
                                style={{
                                  width: 60,
                                  height: 60,
                                  borderRadius: 8,
                                  marginRight: 12,
                                }}
                              />
                            </PhotoView>
                          </PhotoProvider>
                        ) : (
                          <Box
                            sx={{
                              width: 60,
                              height: 60,
                              bgcolor: "action.hover",
                              borderRadius: 2,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              mr: 1.5,
                            }}
                          >
                            <Typography variant="caption">No Image</Typography>
                          </Box>
                        )}
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: 600, fontSize: "0.95rem" }}
                          >
                            {name}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {c.product_quantity || c.quantity} Pack
                          </Typography>
                          {/* <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold" }}
                          >
                            ₹ {c.product_price || c.price || 0}
                          </Typography> */}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
                {(parentRow.combos?.[0]?.combo_addon_details || []).map(
                  (addon, idx) => (
                    <Box
                      key={`addon-${idx}`}
                      sx={{
                        border: "1px solid #ddd",
                        borderRadius: 2,
                        p: 1.5,
                        bgcolor: "background.paper",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {addon.image ? (
                          <PhotoProvider>
                            <PhotoView src={addon.image}>
                              <img
                                src={addon.image}
                                alt={addon.product_name}
                                style={{
                                  width: 60,
                                  height: 60,
                                  borderRadius: 8,
                                  marginRight: 12,
                                }}
                              />
                            </PhotoView>
                          </PhotoProvider>
                        ) : (
                          <Box
                            sx={{
                              width: 60,
                              height: 60,
                              bgcolor: "action.hover",
                              borderRadius: 2,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              mr: 1.5,
                            }}
                          >
                            <Typography variant="caption">No Image</Typography>
                          </Box>
                        )}
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: 600, fontSize: "0.95rem" }}
                          >
                            {addon.product_name}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Add-on
                          </Typography>
                          {/* <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold" }}
                          >
                            ₹ {addon.price}
                          </Typography> */}
                        </Box>
                      </Box>
                    </Box>
                  ),
                )}
              </Box>
            </Box>
          </td>
        </tr>
      );
    },
  };

  const handleClose = () => {
    setOpen(false);
    setOpenImage(false);
    setSelectedRow(null);
  };

  const getDispatchImages = () => {
    const url = "/getDispatchImagesById/" + id;
    setLoader(true);
    axios
      .get(url)
      .then(function (response) {
        setDispatchPrepareImages(response?.data?.data);
      })
      .catch(function (err) {
        toast.error(err?.message);
      })
      .finally(() => {
        setLoader(false);
        dispatch(hideConfirmModal({ msg: "" }));
      });
  };

  const acceptOrders = async () => {
    try {
      const params = {
        dispatch_order_id: id,
      };
      const response = await axios.post("/acceptDispatchOrders", params);

      if (!response?.data?.error) {
        toast.success(response?.data?.message);
        loadInitialData();
        getDispatchImages();
      } else {
        let errDesc = "";
        if (response?.data?.data) {
          Object.values(response?.data?.data).map((error, index) => {
            errDesc =
              index === 0 ? errDesc + error + "\n " : errDesc + error + "\n ";
          });
        } else {
          errDesc = response?.data?.message;
        }

        dispatch(
          showModal({
            msg: errDesc,
            error: response?.data?.error,
          }),
        );
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        }),
      );
    }
  };

  useEffect(() => {
    loadInitialData();
    getDispatchImages();
  }, []);

  function onlyStartTime(slot) {
    let splitArray = slot?.split("to");
    return splitArray?.[0];
  }

  const imageUploadHandler = (orderRow) => {
    setOpenImage(true);
    setSelectedRow((prev) => ({
      ...orderRow,
    }));
    console.log("row", {
      ...orderRow,
    });
  };

  const Info = React.memo(() => {
    return (
      <Dialog open={open} onClose={handleClose} maxWidth={"sm"} fullWidth>
        <DialogTitle className="text-primary">Cake Details</DialogTitle>
        <DialogContent>
          <Grid container columnSpacing={{ xs: 5 }}>
            <Grid item xs={12}>
              <div className="d-flex flex-column">
                <Typography variant="h5" className="mb-0 mobile-view-prod-name">
                  {selectedRow?.product_details?.[0]?.product_name}
                </Typography>

                <Typography variant="subtitle1">
                  Weight:
                  {`${selectedRow?.variation?.weight?.[0]?.weight_name} ${selectedRow?.variation?.weight?.[0]?.unit.unit_name}`}
                </Typography>
                <Typography variant="subtitle1">
                  Quantity: {selectedRow?.product_quantity}
                </Typography>
                {selectedRow?.egg_or_eggless === 0 && (
                  <Typography variant="subtitle1">
                    Cake Type: <span className="text-danger">Egg</span>
                  </Typography>
                )}
                {selectedRow?.egg_or_eggless === 1 && (
                  <Typography variant="subtitle1">
                    Cake Type: <span className="text-success">Eggless</span>
                  </Typography>
                )}
                {selectedRow?.flavour?.flavour_name !== "Default" && (
                  <Typography variant="subtitle1">
                    Flavour: {selectedRow?.flavour?.flavour_name}
                  </Typography>
                )}
                {selectedRow?.message_on_cake !== "" && (
                  <Typography variant="subtitle1">
                    Message On Cake: {selectedRow?.message_on_cake}
                  </Typography>
                )}
                <Typography variant="subtitle1">
                  Slot: {onlyStartTime(dispatchOrder?.[0]?.order.slot_timing)}
                </Typography>
                <Typography variant="subtitle1">
                  Delivery Date: {dispatchOrder?.[0]?.order.expected_delivery}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="error">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  });

  const UpdateImageDialog = () => {
    return (
      <Dialog open={openImage} onClose={handleClose} maxWidth={"xs"}>
        <DialogTitle className="text-primary">Update Image</DialogTitle>
        <Divider variant="middle" className="bg-primary" />

        <DialogContent>
          <Grid container columnSpacing={{ xs: 4 }}>
            <Grid item xs={12}>
              <DispatchImageUpload
                loadInitialData={loadInitialData}
                locationDetailsId={dispatchOrder?.[0]?.location_details_id}
                selectedRow={selectedRow}
                getDispatchImages={getDispatchImages}
                dispatchOrderId={id}
                defaultValue={selectedRow?.image}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="error">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const CommentPopup = () => (
    <Dialog
      fullWidth
      open={commentPopup?.flag}
      onClose={() => setCommentPopup({ flag: false, comments: "" })}
    >
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>{commentPopup?.comments}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setCommentPopup({ flag: false, comments: "" })}
          variant="contained"
          color="error"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  const options = {
    selectableRows: false,
    filter: false,
    download: false,
    viewColumns: false,
    print: false,
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="d-flex  justify-content-between">
            <div className="d-flex">
              <ArrowBackIcon
                className="text-danger"
                sx={{ marginRight: "1rem", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              />
              <h5 className="text-dark">Processing Order Details</h5>
            </div>

            {dispatchOrder?.[0]?.dispatch_order_status != 1 && (
              <Button
                variant="contained"
                color="info"
                onClick={() => acceptOrders()}
              >
                Accept Order
              </Button>
            )}
          </div>

          <Box
            sx={{
              ".normal-row  #expandable-button": {
                display: "none",
              },
              ".normal-row td:first-child": {
                paddingLeft: 0,
              },
            }}
          >
            <MUIDataTable
              title={"Ordered Items"}
              data={combinedTableData}
              columns={itemColumns}
              options={itemTableOptions}
            />
          </Box>

          <MUIDataTable
            data={
              dispatchPrepareImages?.length > 0 ? dispatchPrepareImages : []
            }
            columns={columns}
            options={options}
          />
        </>
      )}
      <Info />
      <UpdateImageDialog />
      <CommentPopup />
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {selectedRow?.confirmLabel} ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmOpen(false)}
            variant="contained"
            color="error"
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={() => selectedRow?.action()}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ViewDispatchOrders;
